import axios from "axios";
import store from '../store'
import { createImageSizeError, findOversizedImage } from '@/utils/imageUploadLimit'

const instance = axios.create();

instance.defaults.baseURL = "/api";

instance.interceptors.request.use((config) => {
    const oversizedImage = findOversizedImage(config.data);

    if (oversizedImage) {
        return Promise.reject(createImageSizeError(oversizedImage));
    }

    // A background request (an automatic refresh) is not user activity, so it must not
    // postpone the idle logout.
    if (!config.background) store.commit("security/setLastRequestOn");
    return config;
});

export default instance;